import { ControllerInterface } from "csi/action/Controller";
import PostRequest from "csi/comm/PostRequest";
import { cnl } from "csi/typings";
import xml from "csi/xml";
import { ILocaleProvider } from "designSystem/locale";
import { AllocationRecordItem, NewAllocatedSupplierRequestStore } from "./NewAllocatedSupplierRequestStore";

/** Create and initialize NewAllocateSupplierRequestStore */
export const createNewAllocateSupplierRequestStore = async (ac: ControllerInterface, locale: ILocaleProvider): Promise<NewAllocatedSupplierRequestStore> => {
	const cache = ac.getCache();
	const context = ac.getParent();
	const srMaster = context?.$Type === "SupplierRequestMaster" ? context : null;
	ac["srMaster"] = srMaster;
	if (srMaster) { // Set fixedType and productField from srMaster
		ac["fixedType"] = srMaster.RequestType;
		ac["productField"] = xml.enumGetText(srMaster.RequestType)+ "s";
	}
	const store = new NewAllocatedSupplierRequestStore(
		cache,
		(view) => ac.getReactSaveDialogProps(view),
		locale,
		ac.getFormData(),
		ac.getParent(),
		ac["isFromHierarchy"],
		srMaster,
		ac["productField"],
	);
	return store;
};

/** Get sources allocation by supplies/Factories and products */
export const getSourcesAllocation = async (sources: cnl[], products: cnl[]): Promise<AllocationRecordItem[]> => {
	const request = new PostRequest("Sourcing", "GetSourcesAllocationForProducts")
		.addParameter("Sources", sources)
		.addParameter("Products", products)
		.addParameter("ExcludeNotAllocatedGroup", false);

	const response = await request.go();
	
	return response?.data ?? [];
};

/** Get SRM sources allocation by existing supplies/Factories and products */
export const getSRMSourcesAllocation = async (supplierRequestMaster: cnl, products: cnl[]): Promise<AllocationRecordItem[]> => {
	const request = new PostRequest("Sourcing", "GetSRMSourcesAllocationForProducts")
		.addParameter("URL", supplierRequestMaster)
		.addParameter("Products", products)
		.addParameter("ExcludeNotAllocatedGroup", true);

	const response = await request.go();
	
	const existingAllocation: AllocationRecordItem[] = response?.data ?? [];
	
	return existingAllocation.map((item: AllocationRecordItem) => {
		item.children?.sort((a, b) =>  {
			return  Number(a.isExisting) - Number(b.isExisting) || a.name.localeCompare(b.name);
		});
		return item;
	});
};